/* ZERON header on every page (v75.36): side menu, sticky glass, features ticker, live cart count.
   The homepage (data-zh-home) already runs the menu/sticky/ticker code in zeron-home.js, so there only the cart count runs here. */
(function(){
  var home=document.documentElement.hasAttribute('data-zh-home');

  if(!home){
    /* side menu */
    var toggle=document.querySelector('.mobile-menu-toggle'), panel=document.querySelector('.mobile-menu-panel'),
        close=document.querySelector('.mobile-menu-close'), backdrop=document.querySelector('.mobile-menu-backdrop');
    if(toggle&&panel){
      var open=function(){ panel.classList.add('is-open'); backdrop&&backdrop.classList.add('is-open'); toggle.setAttribute('aria-expanded','true'); panel.setAttribute('aria-hidden','false'); document.body.classList.add('menu-open'); };
      var shut=function(){ panel.classList.remove('is-open'); backdrop&&backdrop.classList.remove('is-open'); toggle.setAttribute('aria-expanded','false'); panel.setAttribute('aria-hidden','true'); document.body.classList.remove('menu-open'); };
      toggle.addEventListener('click',open); close&&close.addEventListener('click',shut); backdrop&&backdrop.addEventListener('click',shut);
      document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&panel.classList.contains('is-open')) shut(); });
    }
    /* ticker height for the sticky header offset */
    var setTk=function(){ var tk=document.querySelector('.ticker'); if(tk) document.documentElement.style.setProperty('--tk-h',tk.offsetHeight+'px'); };
    setTk(); window.addEventListener('resize',setTk); window.addEventListener('load',setTk);
    /* endless features ticker (same code as the homepage) */
    (function loop(track,speed){
      if(!track) return;
      var kids=[].slice.call(track.children), hid=kids.filter(function(k){return !k.getAttribute('aria-hidden');});
      var base=(hid.length&&hid.length<kids.length)?hid:kids.slice(0,Math.ceil(kids.length/2));
      var protos=base.map(function(k){var c=k.cloneNode(true);c.removeAttribute('aria-hidden');return c;});
      function build(){
        track.style.animation='none'; track.innerHTML='';
        protos.forEach(function(p){track.appendChild(p.cloneNode(true));});
        var setW=track.scrollWidth||1;
        var k=Math.max(1,Math.ceil(1.4*Math.max(window.innerWidth,1600)/setW));
        track.innerHTML='';
        for(var i=0;i<2*k;i++) protos.forEach(function(p){var c=p.cloneNode(true); if(i>0)c.setAttribute('aria-hidden','true'); track.appendChild(c);});
        track.style.setProperty('animation-duration',(k*setW/speed).toFixed(2)+'s','important');
        void track.offsetWidth; track.style.animation='';
        track.style.setProperty('animation-duration',(k*setW/speed).toFixed(2)+'s','important');
      }
      build(); window.addEventListener('load',function(){setTimeout(build,300);});
      var rt; window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(build,250);});
    })(document.querySelector('.ticker-track'),48); /* v75.69 ticker speed px/s (2x) */
  }

  /* live cart count: correct on every page, after any cart change and after the back button */
  function paint(n){
    [].forEach.call(document.querySelectorAll('[data-cart-count]'),function(el){ el.textContent=n; if(n>0) el.removeAttribute('hidden'); else el.setAttribute('hidden',''); });
  }
  var busy=false;
  function refresh(){
    if(busy) return; busy=true;
    fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok?r.json():null; })
      .then(function(c){ busy=false; if(c&&typeof c.item_count==='number') paint(c.item_count); })
      .catch(function(){ busy=false; });
  }
  window.zeronRefreshCartCount=refresh;
  document.addEventListener('cart:refresh',refresh);
  window.addEventListener('pageshow',function(e){ if(e.persisted) refresh(); });
  document.addEventListener('visibilitychange',function(){ if(!document.hidden) refresh(); });
  var CART_RE=/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if(window.fetch&&!window.fetch.__zh){
    var of=window.fetch;
    var wrapped=function(input){
      var url=typeof input==='string'?input:(input&&input.url)||'';
      var p=of.apply(this,arguments);
      if(CART_RE.test(url)) p.then(function(){ setTimeout(refresh,60); },function(){});
      return p;
    };
    wrapped.__zh=true; window.fetch=wrapped;
  }
  if(window.XMLHttpRequest){
    var oo=XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open=function(m,u){ if(CART_RE.test(u||'')) this.addEventListener('load',function(){ setTimeout(refresh,60); }); return oo.apply(this,arguments); };
  }
})();
